import React from 'react';
import { Pressable, StyleSheet } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import type { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { COLORS } from '../config/colors';
import { strings } from '../strings';
import type { RootStackParamList } from '../types/navigation';
import NewsIcon from './icons/NewsIcon';

/**
 * Opens the news screen. It sits in the map's right-hand button column,
 * below `StationListToggleButton` and directly above `GuidesButton`.
 */
const NewsButton = () => {
  const navigation =
    useNavigation<NativeStackNavigationProp<RootStackParamList>>();
  const insets = useSafeAreaInsets();

  const handlePress = () => {
    navigation.navigate('News');
  };

  return (
    <Pressable
      accessibilityLabel={strings.openNews}
      accessibilityRole="button"
      onPress={handlePress}
      style={({ pressed }) => [
        styles.button,
        // Same look as the other floating buttons, placed below the station
        // list toggle: 12 (top inset) + 44 (button) + 12 (gap).
        { top: insets.top + 68, right: 12 },
        pressed && styles.buttonPressed,
      ]}
    >
      <NewsIcon color={COLORS.ink} />
    </Pressable>
  );
};

const styles = StyleSheet.create({
  button: {
    position: 'absolute',
    width: 44,
    height: 44,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 15,
    backgroundColor: COLORS.surface,
    shadowColor: '#000000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 4,
    elevation: 4,
  },
  buttonPressed: {
    opacity: 0.8,
  },
});

export default NewsButton;
